<template>
  <div class="basket-box-modal-slider">
    <DefSlider
      v-if="result.morePhotos"
      :settings="settings"
      :pagination="true"
      :nav="screenWidth >= 992"
    >
      <div v-for="(item, key) in result.morePhotos" :key="key" class="swiper-slide">
        <DefImg :result="item" />
      </div>
    </DefSlider>
    <DefImg v-else :result="result.picture" />
  </div>
</template>

<script>
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'BasketBoxModalSlider',
  components: { DefImg, DefSlider },
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
      settings: {
        slidesPerView: 1,
        // breakpoints: {
        //     968: {
        //         slidesPerView: 6,
        //     },
        //     768: {
        //         slidesPerView: 3.4,
        //     }
        // }
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.basket-box-modal-slider {
  :deep(.def-slider__container) {
    margin-bottom: 4px;
  }
  :deep(.swiper-pagination) {
    min-height: 20px;
  }
}
</style>
